import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { FormattedMessage } from 'react-intl'

import Entity from '../../../../../../../../../../components/Entity'
import VirtualizedList from '../../../../../../../../../../components/VirtualizedList'

import { VIRTUAL_LIST_ID, LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class SearchResults extends Component {
    static propTypes = {
        forceRender: PropTypes.func.isRequired,
        searching: PropTypes.bool.isRequired,
        searchResults: IPropTypes.list.isRequired,
        searchValue: PropTypes.string.isRequired,
    }

    componentDidUpdate(prevProps) {
        const { searchResults: nextSearchResults } = this.props
        const { searchResults, forceRender } = prevProps

        if (searchResults.size === nextSearchResults.size) {
            if (!searchResults.equals(nextSearchResults)) {
                forceRender(VIRTUAL_LIST_ID)
            }
        }
    }

    renderBaseContents = () => {
        const { searchResults, searching, searchValue } = this.props

        if ((!searching && searchResults.size === 0 && searchValue) || !searchValue) {
            return (
                <div className={'search-text'}>
                    <div className={'header'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.${searchValue ? 'subjectNotFound' : 'baseTitle'}`} />
                    </div>
                    <div className={'text'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.${searchValue ? 'subjectNotFoundText' : 'baseText'}`} />
                    </div>
                </div>
            )
        }
        if (searching && searchResults.size === 0) {
            return (
                <div className={'search-loading'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.loadingTitle`} />
                </div>
            )
        }

        return null
    }

    renderItem = (index) => {
        const { searchResults } = this.props

        return <Entity key={`entity_${index}`} entity={searchResults.get(index)} />
    }

    render() {
        const { searchResults } = this.props

        return (
            this.renderBaseContents() || (
                <VirtualizedList
                    id={VIRTUAL_LIST_ID}
                    itemsCount={searchResults.size}
                    itemHeight={61}
                    renderItem={this.renderItem}
                />
            )
        )
    }
}
